import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { botswanaConfig } from '../../../config/botswana-config'
import { coteivoryConfig } from '../../../config/Cote-ivory-config'
import { zimConfig } from '../../../config/zim-config'
import { defaultConfig } from '../../../config/default-config'
import { HttpClient } from '@angular/common/http';
import { ClientSideStorageService } from 'src/app/services/client-side-storage.service';

interface Question {
  question: string;
  answer: string;
  show?: boolean;
}

interface FAQ {
  category: string;
  questions: Question[];
}
@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss'
})
export class FaqsComponent {

  placeholders = environment.placeholders as { [key: string]: string };
  placeHolders: any;
  countryConfig: any;
  logoUrl: any;
  countryName: any;

  searchQuery: string = '';
  showFAQAccordion = true;
  faqs: FAQ[] = [
    {
      category: 'General Information',
      questions: [
        {
          question: "What is Ship2MyID?",
          answer: "Ship2MyID is a digital platform connecting brands, retailers, and consumers through a web-based portal. It allows merchants to showcase their products and services, offering a seamless shopping experience for consumers."
        },
        {
          question: "What types of products or services can I use Ship2MyID for?",
          answer: "Ship2MyID is a versatile platform that supports a wide array of products and services across multiple industries. Whether your business operates in retail, hospitality, or another sector, Ship2MyID is designed to help you efficiently manage and optimize your conversion process. The platform's flexibility allows you to customize your offerings to meet the specific needs of your customers, ensuring a seamless and effective user experience."
        },
        {
          question: "Is Ship2MyID available internationally?",
          answer: "Yes, Ship2MyID operates in multiple countries, providing a global platform for businesses to showcase their products and connect with a worldwide audience."
        },
        {
          question: "How does Ship2MyID ensure data privacy and security?",
          answer: "Ship2MyID uses robust encryption, strict access controls, and regular security audits to ensure data privacy and security. All transactions are protected through advanced security measures."
        },
        {
          question: "Are there any fees associated with using Ship2MyID?",
          answer: "Ship2MyID offers flexible pricing plans, including subscription-based models or transaction-based fees. The exact fees vary based on the selected features and services."
        },
        {
          question: "Can I integrate my existing e-commerce platform with Ship2MyID?",
          answer: "Yes, Ship2MyID seamlessly integrates with existing e-commerce platforms, enabling smooth synchronization of inventory, orders, and customer data across multiple channels."
        }
      ]
    },
    {
      category: 'Getting Started',
      questions: [
        {
          question: "How can my business sign up for Ship2MyID?",
          answer: "Businesses can sign up by visiting the official website Merchant Portal or contacting the support team. The sign-up process involves providing basic information about the business and agreeing to the platform's terms and conditions."
        },
        {
          question: "What are the eligibility criteria for joining Ship2MyID?",
          answer: "Businesses must adhere to the legal and regulatory requirements specific to their country or region, comply with our platform policies, and validate their business credentials. Our partners are expected to rigorously follow these regulations to join and operate on Ship2MyID."
        },
        {
          question: "What are the business categories that can't register with Ship2MyID?",
          answer: "Registration with Ship2MyID is subject to both our internal policies and the governmental regulations of the county. Specifically, businesses that fall under restricted categories, as defined by our platform's guidelines and local government policies, are not eligible for registration. These restrictions are in place to ensure compliance with legal standards and to maintain the integrity and security of the platform."
        },
        {
          question: "Is there a verification process for businesses before they can start using the platform?",
          answer: "Yes, Ship2MyID employs a verification process to authenticate the identity and legitimacy of businesses. This may involve submitting relevant documents or undergoing background checks."
        }
      ]
    },
    {
      category: 'Registration Process',
      questions: [
        {
          question: "What information is required during the Registration process?",
          answer: "Businesses must provide business entity details and contact details. Supporting documentation such as licenses and certificates may also be required."
        },
        {
          question: "How long does the registration process take?",
          answer: "The registration process typically takes up to three working days following the submission of all necessary information by the business entity."
        },
        {
          question: "Can I customize my business profile on Ship2MyID?",
          answer: "Yes, businesses can customize their profiles with logos, product images, and descriptive text to create a unique storefront."
        }
      ]
    },
    {
      category: 'Platform Features and Functionality',
      questions: [
        {
          question: "What support does Ship2MyID offer to businesses?",
          answer: "Ship2MyID offers businesses the capability of creating deals, running campaigns, accessing a list of ready-to-buy consumers in real-time, supportive customer support, training material, initial support for creating campaigns, and insights."
        },
        {
          question: "Can Businesses run promotional campaigns through the platform?",
          answer: "Yes, businesses can launch promotional campaigns, offer discounts, implement re-targeting strategies, and create special offers on Ship2MyID. The platform includes robust tools for designing and managing these promotions, along with capabilities for tracking performance and analyzing their effectiveness."
        },
        {
          question: "How can Businesses track the performance of my products on the platform?",
          answer: "The platform provides comprehensive insights and reporting tools to monitor sales, website traffic, conversion rates, and customer engagement. These analytics empower businesses to refine their marketing strategies and make informed decisions for enhanced performance."
        },
        {
          question: "Can Businesses manage inventory and orders through the platform?",
          answer: "No, Ship2MyID does not offer those features."
        },
        {
          question: "Is there a customer feedback and review system on the platform?",
          answer: "No, the platform does not currently include a customer feedback and review system. We are constantly exploring new features to enhance our services and will consider adding review capabilities in the future."
        }
      ]
    },
    {
      "category": "Payments and Transactions",
      "questions": [
        {
          question: "What payment options are available for customers?",
          answer: "The platform supports multiple payment options, including credit and debit cards, digital wallets, bank transfers, and UPI (where available)"
        }
      ]
    },
    {
      category: 'Support and Assistance',
      questions: [
        {
          question: "What support options are available for businesses using the platform?",
          answer: "The platform provides online help resources, including knowledge base articles and instructional videos. For further assistance, you can contact us via email at merchant@ship2myid. Live chat support is available through the 'Help & Support' tab in the portal or via the chat widget located at the bottom right of the screen. Please note that our support is operational according to your country or region's time zone."
        },
        {
          question: "How can businesses report technical issues or request assistance?",
          answer: "Businesses can report technical issues or request assistance by contacting the support team via email or live chat."
        },
        {
          question: "How can businesses access the instructional videos on the platform?",
          answer: "Instructional videos can be accessed through the 'Help & Support' section in your merchant dashboard. Simply navigate to this section, and you will find a library of videos organized by topic to assist you with various platform features."
        },
        {
          question: "Can businesses request one-on-one support for specific issues?",
          answer: "Yes, businesses can request one-on-one support by contacting our customer support team via email or live chat. If your issue requires personalized assistance, our team will arrange a dedicated session to resolve the matter."
        },
        {
          question: "What are the support hours for businesses in different time zones?",
          answer: "Our support hours vary depending on your country or region’s time zone. You can find the specific support hours for your location in the 'Help & Support' section of the platform."
        },
        {
          question: "How can businesses submit feedback or suggestions for platform improvements?",
          answer: "You can submit feedback or suggestions by emailing us at merchant@ship2myid. We value your input and continuously work to enhance the platform based on your feedback."
        },
        {
          question: "What should I do if I can't find a solution in the help resources or instructional videos?",
          answer: "If you can't find a solution in the help resources or instructional videos, please reach out to our support team via email or live chat. Our team will assist you promptly and ensure your issue is resolved."
        },
        {
          question: "Can businesses contact support outside of regular hours in case of an emergency?",
          answer: "While our support team is available during business hours based on your region's time zone, businesses experiencing critical issues can contact our emergency support line or submit a ticket, and we will prioritize urgent matters accordingly."
        }
      ]
    },
    {
      category: 'Security and Compliance',
      questions: [
        {
          question: "How does the platform ensure data security and compliance?",
          answer: "The platform adheres to strict data security protocols and compliance standards, including encryption, access controls, and regular security audits."
        },
        {
          question: "Are businesses required to comply with specific regulations when using the platform?",
          answer: "Yes, businesses must comply with regulations governing e-commerce, as well as Ship2MyID's terms and conditions, data protection laws, consumer rights, and advertising standards. The platform offers guidance to assist businesses in adhering to these requirements."
        }
      ]
    },
    {
      category: 'Account Management and Termination',
      questions: [
        {
          question: "Can businesses deactivate or terminate their accounts on the platform?",
          answer: "Yes, businesses can deactivate or terminate their accounts by contacting the support team and following the account closure process. Certain terms and conditions may apply."
        },
        {
          question: "Can a business join back after deactivation?",
          answer: "Once an account is deactivated, the business must complete the registration process from the beginning to reactivate their account. This involves providing the necessary information and going through the initial set-up steps as if registering for the first time. This ensures that all details are up-to-date and that the account is properly configured for continued use."
        },
        {
          question: "What happens to data and content upon account termination?",
          answer: "Upon termination, the platform securely deletes or anonymizes all associated data and content in accordance with data retention policies and regulatory requirements. Businesses can request data export or deletion as needed."
        }
      ]
    },
    {
      category: 'Marketing and Promotion',
      questions: [
        {
          question: "How can businesses utilize the platform for marketing and promotion?",
          answer: "Businesses can leverage the platform's robust promotional tools to craft highly targeted marketing campaigns, design customized discounts, and develop exclusive offers. These features are designed to help you effectively attract and engage customers, driving increased visibility and growth for your business."
        },
        {
          question: "Does the platform provide insights into marketing campaign performance?",
          answer: "Yes, the platform offers insights and reporting tools to track the performance of marketing campaigns, helping businesses optimize their strategies."
        }
      ]
    },
    {
      category: 'Customer Engagement',
      questions: [
        {
          question: "How can businesses engage with consumers through the Ship2MyID platform?",
          answer: "Yes, you can engage with customers even if you don’t have their personally identifiable information (PII). Businesses can use the Ship2MyID platform to create personalized promotional offers. The platform provides tools for designing targeted marketing campaigns, customized discounts, and special offers based on consumer preferences and behaviors. This allows businesses to connect with their audience more effectively, enhance customer experiences, and foster greater engagement and loyalty."
        },
        {
          question: "Is there a loyalty program feature on the platform?",
          answer: "Currently, we do not offer a loyalty program feature. However, we plan to introduce this in the near future to help our merchants reward customers and encourage repeat business."
        }
      ]
    },
    {
      category: 'Reporting and Analytics',
      questions: [
        {
          question: "What types of reports are available through the platform?",
          answer: "The platform offers various reports, including sales reports, traffic analytics, conversion rates, and customer engagement metrics, to help businesses analyze their performance."
        },
        {
          question: "Can businesses export their data for further analysis?",
          answer: "Yes, the platform allows businesses to export their data for further analysis and integration with other business tools."
        }
      ]
    },
    {
      category: 'Business Model and Solutions',
      questions: [
        {
          question: "How does Ship2MyID ensure consumer privacy?",
          answer: "Ship2MyID employs patented technology to ensure the highest level of consumer privacy. As the only platform in the world with this innovative technology, we facilitate transactions and interactions between individual consumers and brands without disclosing personally identifiable information (PII). Our system replaces PII with demographic information, eliminating privacy risks. Additionally, Ship2MyID adheres to stringent data privacy standards, ensuring 100% compliance with prevailing data regulations and safeguarding all consumer data with the utmost security and integrity."
        },
        {
          question: "Can Ship2MyID help my business reach international markets?",
          answer: "Yes, Ship2MyID is designed to connect global brands and retailers with consumers worldwide who have a direct intent to purchase. Currently, we are in the pilot stage, and while the export option for international markets is anticipated to be available in the coming days, our services are presently limited to within county boundaries. We are actively working to expand our capabilities to support international business growth."
        },
        {
          question: "What is the Digital ID offered by Ship2MyID?",
          answer: "The Digital ID is a unique lifetime identifier for every consumer, replacing traditional identity and address systems. It allows consumers to manage their own privacy and provides a secure means of conducting transactions."
        },
        {
          question: "How does Ship2MyID's consumer-led marketing approach work?",
          answer: "Unlike conventional seller-driven campaigns, Ship2MyID empowers consumers to choose what they want, when they want it, and from whom they want it in real time. This consumer-centric approach not only enhances conversion rates but also guarantees full compliance with data privacy regulations."
        },
        {
          question: "How does Ship2MyID support local and regional merchants?",
          answer: "Ship2MyID supports local and regional merchants by facilitating direct-to-consumer marketing, allowing them to connect more effectively with their target audience. Once brands are registered and onboarded on the platform, they will have access to tutorial videos for do-it-yourself (DIY) guidance. Additionally, our support team is available to provide initial assistance with running campaigns and offer ongoing support to address any concerns and ensure a smooth experience. This comprehensive support structure helps local businesses thrive and achieve their marketing goals while maintaining data privacy."
        },
        {
          question: "What types of solutions does Ship2MyID offer to Businesses?",
          answer: "Ship2MyID provides secure communication channels for personalized marketing campaigns, connecting businesses with verified consumers who have a clear intent to purchase, thus maximizing marketing ROI."
        }
      ]
    },
    {
      category: 'Implementation and Integration',
      questions: [
        {
          question: "What training and support does Ship2MyID offer to new merchants?",
          answer: "Ship2MyID provides comprehensive onboarding, training materials, and ongoing support to help new merchants get started and make the most of the platform’s features."
        },
        {
          question: "What kind of reporting and analytics are available for merchants on Ship2MyID?",
          answer: "Ship2MyID provides detailed reporting and analytics, including insights into sales performance, customer engagement, and campaign effectiveness, helping merchants optimize their strategies and improve business."
        }
      ]
    },
    {
      category: 'Maximizing Sales and Driving Conversions',
      questions: [
        {
          question: "Why are my conversions low?",
          answer: "Low conversions could result from unclear messaging in advertisements, unattractive offers, incorrect audience targeting, poor landing page experience, or lack of trust signals like reviews and security badges."
        },
        {
          question: "How can I improve my conversion rates?",
          answer: "Improve conversions by optimizing ad content, offering compelling and relevant promotions, refining audience targeting, simplifying the purchase process, and ensuring landing pages are mobile-friendly and fast-loading."
        },
        {
          question: "Why is targeting the right audience important for conversions?",
          answer: "Proper targeting ensures that your campaign reaches users who are most likely to engage with your product or service. This minimizes wasted ad spend and maximizes the effectiveness of your marketing efforts."
        },
        {
          question: "What role does product pricing play in conversions?",
          answer: "Transparent and competitive pricing is crucial. Unclear or hidden costs can discourage potential customers. Highlighting discounts, free shipping, or added value can positively influence purchasing decisions."
        },
        {
          question: "How can I reduce cart abandonment rates?",
          answer: "Minimize cart abandonment by simplifying the checkout process, offering multiple payment options, displaying clear pricing, and using exit-intent popups with exclusive offers to encourage users to complete their purchase."
        },
        {
          question: "What is the impact of page speed on conversions?",
          answer: "Slow page loading times can frustrate users and lead to high bounce rates. Optimizing page speed ensures a smooth user experience, helping retain visitors and increasing the likelihood of conversions."
        },
        {
          question: "Why is mobile optimization critical for conversions?",
          answer: "A large percentage of users shop on mobile devices. Ensuring your website or landing page is mobile-friendly improves accessibility and provides a seamless user experience, directly impacting conversion rates."
        },
        {
          question: "How do retargeting campaigns help in improving conversions?",
          answer: "Retargeting campaigns engage users who showed initial interest but did not convert. By displaying personalized ads, you can re-capture their attention and encourage them to complete their purchase."
        }
      ]
    },
  ];

  filteredFaqs: FAQ[] = this.faqs;
  // filterFAQs() {
  //   const lowerCaseSearchTerm = this.searchQuery.toLowerCase();

  //   this.filteredFaqs = this.faqs.map(faq => ({
  //     category: faq.category,
  //     questions: faq.questions.filter(q =>
  //       q.question.toLowerCase().includes(lowerCaseSearchTerm) ||
  //       q.answer.toLowerCase().includes(lowerCaseSearchTerm) ||
  //       faq.category.toLowerCase().includes(lowerCaseSearchTerm)
  //     )
  //   })).filter(faq => faq.questions.length > 0);
  // }
  expandedIndexes: number[] = [];
  filterFAQs() {
    const lowerCaseSearchTerm = this.searchQuery.toLowerCase();

    // Filter the FAQs
    this.filteredFaqs = this.faqs.map(faq => ({
      category: faq.category,
      questions: faq.questions.filter(q =>
        q.question.toLowerCase().includes(lowerCaseSearchTerm) ||
        q.answer.toLowerCase().includes(lowerCaseSearchTerm) ||
        faq.category.toLowerCase().includes(lowerCaseSearchTerm)
      )
    })).filter(faq => faq.questions.length > 0);

    // Expand all matching panels
    this.expandedIndexes = this.filteredFaqs.map((faq, index) => index);
  }

  toggleFAQAccordion() {
    this.showFAQAccordion = !this.showFAQAccordion;
  }

  constructor(private route: ActivatedRoute, private cStorage:ClientSideStorageService,private router: Router, private http: HttpClient) {
    this.placeHolders = this.placeholders['Help_Support']
    this.macAddress = Math.random();
    this.cStorage.set('country', JSON.stringify([]));
    this.cStorage.set('macAddress', JSON.stringify(this.macAddress));
    this.country = JSON.parse(this.cStorage.get("country"));
    this.macAddress = JSON.parse(this.cStorage.get("macAddress"));
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const country = params['country'];
      debugger
      if (country) {
        this.countryName = country
        this.countryConfig = this.getConfigByCountry(this.countryName) ?? defaultConfig;
        this.logoUrl = this.countryConfig.headerpostlogo;
        this.loadTermsForCountryAPI(this.countryName)

        // Remove ?country=... from URL cleanly
        this.router.navigate([], {
          queryParams: {},
          replaceUrl: true
        });

      } else {
        this.countryName = 'country'

      }
    });

  }

  // countryConfig: any;
  country: any;
  macAddress: any;
  loadTermsForCountryAPI(country: any) {
    debugger
    // const countryName = CountryMap[country];
    const httpOptions = {
      // 'userName': 'satheshjkv@gmail.com',
      'macAddress': this.macAddress,
      'country': this.country
    };
    let countryid = parseInt(this.countryName)
    let locale = this.countryConfig.language.toUpperCase()
    const url = environment.authUrl + `orchestration-service/admin/api/faqs?country=${countryid}&type=MERCHANT&locale=${locale}&componentType=TERMS`;
    this.http.get(url, { headers: httpOptions, observe: 'response', withCredentials: true }).subscribe(
      html => this.filteredFaqs = (html as any).body?.data?.questionCategoriesDTOList,
      // err: any => this.filteredFaqs = '<p>Terms not available for this region.</p>'
    );
  }


  getConfigByCountry(country: any): any {
    switch (country) {
      case '72':
        return botswanaConfig;
      case '716':
        return zimConfig;
      case '384':
        return coteivoryConfig;
      default:
        return defaultConfig;
    }
  }

}

